define('common/appoint', [
    'jquery',
    'data/intent',
    'widget/dialog/success',
    'md5',
    'common/util',
    'jquery.cookie',
], ($, intent, dialog, md5, util) => {
    /*
     * 预约看车
     */
    const option = {
        title: '您预约的车辆',
        successMessage: intent.getMessage(),
    };
    let initialData = {};
    let action = ''; // 线索类型
    const ndLoggedScheduleModal = $('#js-logged-schedule-modal');

    // TODO refactor required
    // 预约线索拆分, 新增 action 参数
    const init = (data, opt, actionParam) => {
        action = actionParam;
        if (data) {
            initialData = data;
        }
        if (opt) {
            $.extend(option, opt);
        }
    };

    const show = () => {
        ndLoggedScheduleModal
            .find('.dialog-title')
            .text(option.title);

        ndLoggedScheduleModal
            .find('.form-wrapper .error')
            .hide();

        if (option.carTitle) {
            ndLoggedScheduleModal
                .find('.title')
                .text(option.carTitle);
        }

        ndLoggedScheduleModal.fullscreen('show');
    };

    function _intent() {
        const $inMobile = $('#js-schedule-mobile-number');
        const $inPhoneSource = $('.schedule_phone_source');
        const data = {};
        $.extend(data, {
            mobile_number: $.trim($inMobile.val()),
            car_id: $('.detail-wrapper')
                .data('id'),
            phone_source: $inPhoneSource.val(),
            token: RRC.csrftoken,
        }, initialData);

        // 成功后的回调
        const success = (argument) => {
            $('#schedule_modal')
                .find('div[aria-hidden="true"]')
                .trigger('click');

            $('#js-verification-modal')
                .fullscreen('hide');

            if (argument.status === 0) {
                let message = option.successMessage;
                if (Array.isArray(message)) {
                    message = message.map(item => `<p style="margin-bottom: 5px;">${item}</p>`).join('');
                }
                let remind = `<div class="confirm__message">${message}</div>`;
                if (parseInt(RRC.ino, 10)) {
                    remind +=
                        '<p><a href="/p/10/renrenche_yidigouche" target="_blank">了解异地购车注意事项 ></a></p>';
                }
                dialog('提交成功', remind, '/dist/images/default-qr-b2621fb1.png');
                _fxcmd.push([
                    'trackEvent',
                    'event',
                    'cvr1',
                    md5(data.mobile_number),
                    '1',
                ]);
                if (RRC.pageName === 'car-detail') {
                    // 在详情页种植会话SESSION 保证弹窗出现后其他逻辑的弹窗不出现
                    RRC.SHOW_DETAIL_LAYER_MASK = false;
                }
            }
        };
        intent(action, data, success, '/dist/images/default-qr-b2621fb1.png');
    }

    // 提交按钮事件绑定
    /* istanbul ignore next */
    $('body')
        .on('click', '#js-schedule_submit', () => {
            const $provisionSelect = $('#js-appoint-provision-select');
            // 解决js单测问题
            if ($provisionSelect[0]) {
                const state = $provisionSelect.hasClass('selected');
                if (!state) return;
            }
            const $inMobile = $('#js-schedule-mobile-number');

            if (!$inMobile.val() || $inMobile.data('error') === 'true') {
                $inMobile.focus();
                return;
            }
            ndLoggedScheduleModal.fullscreen('hide');
            _intent();
        });

    // 线索提交下法务提示
    util.intentLawHandle($('#js-appoint-provision-select'), $('#js-schedule_submit'));

    /* istanbul ignore next */
    $('#js-schedule-mobile-number')
        .on('focus', function () {
            $(this).data('editing', 'true');
        })
        .on('change', function () {
            $(this).data('editing', 'true');
        })
        .on('blur', function () {
            $(this).data('editing', 'false');
            $(this).parent().removeClass('error');
            $(this).data('error', 'false');

            const val = $.trim($(this).val());
            if (val) {
                if (!util.isMobile(val)) {
                    $(this).parent().addClass('error');
                    $(this).data('error', 'true');
                    $(this).parent().find('.error').show();
                } else {
                    $(this).parent().find('.error').hide();
                }
            } else {
                $(this).parent().find('.error').show();
            }
        });

    return {
        show,
        init,
        intentAppointent: _intent,
    };
});
